import styled, { css } from 'styled-components';
import { Button as DefaultButton } from '~components';

interface IList {
  showIncolumns?: boolean;
}

export const List = styled.ul<IList>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km4};

  ${({ showIncolumns = false, theme }) =>
    showIncolumns &&
    css`
      @media (min-width: ${theme.breakpoint.lg.minWidth}) {
        height: 64px;
        width: 548px;
        flex-wrap: wrap;
      }
    `}
`;

export const Item = styled.li`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const Button = styled(DefaultButton).attrs({
  variant: 'secondary',
})`
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
    margin-left: ${({ theme }) => theme.spacing.km0};
  }
`;

export const CheckIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 22px;
  border-radius: ${({ theme }) => theme.border.radius.small};
  background: ${({ theme }) => theme.color.support.green.weak};
`;
